/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'report': {
    width: 25,
    height: 25,
    viewBox: '0 0 25 25',
    data: '<path pid="0" _fill="#008cff" d="M8.79 16.602h5.956v1.953H8.79zm0-3.907h11.327v1.953H8.79zM25 6.835v11.19L18.058 25H6.836a2.933 2.933 0 01-2.93-2.93v-.976H2.93A2.933 2.933 0 010 18.164V2.93A2.933 2.933 0 012.93 0h15.234a2.933 2.933 0 012.93 2.93v.976h.976A2.933 2.933 0 0125 6.836zM6.836 3.907H19.14V2.93a.978.978 0 00-.977-.977H2.93a.978.978 0 00-.977.977v15.234c0 .539.438.977.977.977h.976V6.836a2.933 2.933 0 012.93-2.93zm14.838 14.692h-2.05a.978.978 0 00-.977.977v2.064zm1.373-11.762a.978.978 0 00-.977-.977H6.836a.978.978 0 00-.977.977V22.07c0 .539.438.977.977.977h9.858v-3.472a2.933 2.933 0 012.93-2.93h3.423zM8.789 8.789h11.328v1.953H8.79z"/>'
  }
})
